export default {
	create: "create",
	read: "read",
	update: "update",
	delete: "delete"
}